import { CommonKeys } from "../../../common/enums";
import type { StammElement } from "./StammElement";

export const STAMM_VERTRAG_TYPE = "AM_Services.Domain.Models.Formulare.StammElementVertrag, AM_Services.Domain.Standard";

export const FormularGroupStammStammElementVertragSchema = {
    $id: "FormularGroupStammStammElementVertragSchema",
    title: "FormularGroupStammStammElementVertrag Schema",
    type: "object",
    allOf: [
        { $ref: "FormularGroupStammStammElementBaseSchema" },
        {
            type: "object",
            properties: {
                [CommonKeys.Type]: { const: STAMM_VERTRAG_TYPE },
                Property: { type: "number", nullable: true }
            }
        }
    ],
};

export interface StammElementVertrag extends StammElement {
    Property: StammElementVertragProperty
}

export enum StammElementVertragProperty {
    VertragsArt, Vertragsnummer,
    // Use VertragsnehmerEinzeilig instead
    Vertragsnehmer,
    VertragsnehmerEinzeilig, VertragsnehmerPostanschrift,
    ClientName, ClientStreet, ClientPostalCodeCity,
    AdjInvAddressOneLine,
    AdjInvAddressPostal,
    AdjInvAddressNameComplete,
    AdjInvAddressStreet,
    AdjInvAddressPostalCodeCity,
    DetermineAddressOneLine,
    DetermineAddressPostal,
    DetermineAddressNameComplete,
    DetermineAddressName1,
    DetermineAddressName2,
    DetermineAddressName3,
    DetermineAddressName4,
    DetermineAddressStreet,
    DetermineAddressPostalCodeCity,
    Kurzbeschreibung, Gesamtwert
}